import * as React from 'react'
import { Checkbox, makeStyles, Text, Tooltip } from '@fluentui/react-components'
import PersonAvatar from '../../../components/PersonAvatar'
import { DateFormats } from '../../../helpers/dateHelper'
import { useTranslation } from 'react-i18next'
import MoneyText from '../../../components/Text/Currency/MoneyText'
import { InvoiceStatusLabels } from '../../../components/TagPicker/InvoiceStatusPicker'
import { BaseFixedPriceLineOverviewProps, useItemStyles } from './BaseFixedPriceOverview'
import FormattedDate from '../../../components/Date/FormattedDate'
import { useOverviewStyles } from '../../../pages/BaseOverview/BaseOverview'
import { Link } from 'react-router-dom'
import { BillableIcon } from '../Travel/TravelListItem'
import { Billable } from '../../../config/registration/timeConfig'
import TooltippedText from '../../components/Text/TooltippedText'

const useStyles = makeStyles({
    nameDescription: {
        display: 'flex',
        flexDirection: 'column',
    },
})

function TurnoverField(props: BaseFixedPriceLineOverviewProps) {
    const { t: translate } = useTranslation()

    return (
        <Tooltip
            relationship={'label'}
            content={
                <div>
                    <div>
                        {translate('registration.rate')}: <MoneyText value={props.item.rate} inline />
                    </div>
                </div>
            }
            withArrow
        >
            <div>
                {/*Apply a diff as the Tooltip needs a html component other than span.*/}
                <MoneyText value={props.item.turnover} align="right" />
            </div>
        </Tooltip>
    )
}

function InvoiceTurnoverField(props: BaseFixedPriceLineOverviewProps) {
    const { t: translate } = useTranslation()

    return (
        <Tooltip
            relationship={'label'}
            content={
                <>
                    <div>
                        {translate('invoice.edit.form.header.number')}: {props.item.invoice.number}
                    </div>
                    <div>
                        {translate('invoice.status.label')}: {translate(InvoiceStatusLabels.get(props.item.invoice.status).name, { count: 0 })}
                    </div>
                </>
            }
            withArrow
        >
            <Link to={`/invoice/${props.item.invoice.id}/edit`}>
                <MoneyText value={props.item.invoiceTurnover} align="right" />
            </Link>
        </Tooltip>
    )
}

// The name (type) stacked above the free description; the description carries the long description as a tooltip.
function NameDescription(props: BaseFixedPriceLineOverviewProps) {
    const itemStyles = useItemStyles()
    const styles = useStyles()

    return (
        <div className={styles.nameDescription}>
            <Text>{props.item.name}</Text>
            <TooltippedText className={itemStyles.listFixedPriceItemOverflow} richTooltip tooltip={props.item.longDescription}>
                {props.item.description}
            </TooltippedText>
        </div>
    )
}

export default function FixedPriceListItem(props: BaseFixedPriceLineOverviewProps) {
    const itemStyles = useItemStyles()
    const overviewStyles = useOverviewStyles()

    if (props.viewportNarrow) {
        return (
            <>
                {props.onItemSelected && (
                    <Checkbox
                        className={overviewStyles.centerItems}
                        checked={props.isItemSelected?.(props.item)}
                        disabled={!props.isItemSelectable?.(props.item)}
                        onChange={(_, data) => props.onItemSelected(data, props.item)}
                    />
                )}
                <PersonAvatar name={props.item.user.fullName} color={'colorful'} size={24} />
                <NameDescription {...props} />
                {props.onItemSelected && <div></div>}
                <div>
                    <FormattedDate date={props.item.date} format={DateFormats.Full} />
                </div>
                <div className={props.viewportTiny ? itemStyles.listFixedPriceItemTinyBottomRow : itemStyles.listFixedPriceItemSmallBottomRow}>
                    <div></div>
                    <TurnoverField {...props} />
                    {!props.viewportTiny && !props.hideInvoiceField && props.item.invoice && <InvoiceTurnoverField {...props} />}
                    {!props.viewportTiny && !props.hideInvoiceField && !props.item.invoice && <BillableIcon billable={Billable.Billable} />}
                </div>
            </>
        )
    }

    return (
        <>
            {props.onItemSelected && (
                <Checkbox
                    className={overviewStyles.centerItems}
                    checked={props.isItemSelected?.(props.item)}
                    disabled={!props.isItemSelectable?.(props.item)}
                    onChange={(_, data) => props.onItemSelected(data, props.item)}
                />
            )}
            <PersonAvatar name={props.item.user.fullName} color={'colorful'} size={24} />
            <div>
                <FormattedDate date={props.item.date} format={DateFormats.Full} />
            </div>
            <NameDescription {...props} />
            <TurnoverField {...props} />
            {!props.hideInvoiceField && props.item.invoice && <InvoiceTurnoverField {...props} />}
            {!props.hideInvoiceField && !props.item.invoice && <BillableIcon billable={Billable.Billable} />}
        </>
    )
}
